"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
const faqs = [{
  question: "Como a MASTERPRO+ auxilia na longevidade profissional?",
  answer: "Nossa metodologia foca na atualização constante de competências e no reposicionamento estratégico de carreira. Através de mentorias personalizadas, ajudamos líderes experientes a identificar novas oportunidades no mercado corporativo ou em conselhos consultivos, garantindo que sua trajetória continue relevante e valorizada."
}, {
  question: "O programa de liderança é voltado para quais níveis?",
  answer: "Focamos em executivos C-Level, diretores e gestores seniores que buscam refinar sua influência e impacto organizacional. O programa aborda desde inteligência emocional avançada até gestão de crises e liderança transformacional em ambientes de alta complexidade."
}, {
  question: "Como funciona o networking estratégico da rede?",
  answer: "Oferecemos acesso a um ecossistema exclusivo de profissionais de alto nível. Através de eventos fechados, fóruns de discussão e conexões diretas, facilitamos parcerias de negócios e trocas de experiências que seriam inacessíveis em redes convencionais."
}, {
  question: "Qual o diferencial da orientação para conselheiros?",
  answer: "Preparamos executivos para a transição para conselhos de administração, focando em governança corporativa, visão holística de negócios e o papel consultivo. Nossa orientação é prática, baseada em casos reais e nas demandas atuais das grandes corporações brasileiras."
}, {
  question: "Qual a duração média dos programas de mentoria?",
  answer: "Os programas são modulares e adaptados à agenda do executivo, variando geralmente entre 4 a 8 meses, com sessões estratégicas quinzenais ou mensais para garantir a implementação real dos conceitos discutidos."
}, {
  question: "As sessões são presenciais ou online?",
  answer: "Oferecemos flexibilidade total. As mentorias podem ser realizadas de forma 100% digital para executivos globais, ou em formato híbrido com encontros presenciais em nossos hubs de negócios em São Paulo."
}, {
  question: "Existe algum processo de seleção para novos membros?",
  answer: "Sim, para manter a alta qualidade do networking, realizamos uma entrevista de alinhamento para entender se o momento de carreira do profissional converge com os objetivos da nossa comunidade exclusiva."
}, {
  question: "Como a MASTERPRO+ aborda a inteligência emocional?",
  answer: "Utilizamos ferramentas de assessment de última geração e simulações de cenários críticos para desenvolver a resiliência e a capacidade de tomada de decisão sob pressão, competências vitais para a liderança moderna."
}, {
  question: "Posso contratar mentorias específicas para minha equipe?",
  answer: "Sim, desenvolvemos programas In-Company focados no desenvolvimento de sucessores e no alinhamento cultural de times de alta gestão, potencializando os resultados coletivos da organização."
}];
export default function FaqAccordionCoachingValue() {
  return <section data-section-id="252312" id="premiumexecutivefaq" className="w-full flex flex-col bg-background text-foreground">
      {}
      

      {}
      <div className="w-full bg-gradient-to-b from-background to-muted/30 py-20 md:py-32 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-serif font-bold text-4xl md:text-5xl lg:text-6xl text-foreground mb-16 md:mb-24 text-center md:text-left tracking-tight">
            FAQ da MASTERPRO+
          </h2>
          <Accordion type="single" collapsible className="w-full space-y-10">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border/50">
                <AccordionTrigger className="text-foreground hover:text-primary font-default font-semibold text-xl md:text-2xl text-left hover:no-underline py-6 [&>svg]:text-primary [&>svg]:size-6 transition-colors duration-300">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-default font-normal text-base md:text-lg leading-relaxed pt-2 pb-8">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>

          <div className="mt-20 pt-12 border-t border-border flex flex-col items-center text-center">
            <p className="text-muted-foreground font-sans text-lg mb-8">
              Ainda tem perguntas sobre sua trajetória executiva?
            </p>
            <Link to="https://wa.me/5511966187866" newTab className="bg-primary text-primary-foreground px-10 py-4 rounded-lg font-default font-semibold uppercase tracking-wider hover:opacity-90 transition-all shadow-md inline-block">
              FALAR COM UM CONSULTOR
            </Link>
          </div>
        </div>
      </div>
    </section>;
}